/**
 * Namespace `partnerWallet` — PLAT-2026-122: ví trả trước của đối tác (Tingee), webhook bị chặn, hạn mức giao dịch. Dùng ở
 * hộp Cấu hình tích hợp, tab « Ví & hạn mức » của Báo cáo đối tác, dải trên trang « Cần xử lý » và « Tổng quan ». Bản gốc
 * tiếng Việt.
 */
export const partnerWallet = {
  title: "Ví & hạn mức đối tác",
  intro:
    "Tingee tính Bube bằng VÍ TOKEN trả trước (1 token = 1 ₫, 150 token mỗi webhook giao dịch, lô token có hạn dùng); ví cạn thì Tingee CHẶN webhook và khách không thấy tiền về tức thì. Tingee không có API số dư — hub ước tính từ số dư bạn đọc ở cổng baas.tingee.vn + số lượt webhook bube-banktransfer đếm được.",
  loadFailed: "Không tải được ví đối tác.",
  sectionTitle: "Ví token (trả trước)",
  sectionHint:
    "Số dư là ƯỚC TÍNH: số đọc gần nhất ở cổng − lượt webhook × giá. Nhập số dư mới mỗi khi xem cổng để hub tự hiệu chỉnh (độ lệch).",
  openReport: "Xem đầy đủ ở Báo cáo đối tác",
  "level.blocked": "Đang chặn",
  "level.critical": "Sắp cạn (< 3 ngày)",
  "level.low": "Còn ít (< 7 ngày)",
  "level.incomplete": "Thiếu số liệu",
  "level.watch": "Theo dõi (< 14 ngày)",
  "level.ok": "Đủ dùng",
  "level.unknown": "Chưa đo được",
  "issue.no_pricing":
    "Chưa có giá ở bộ thông số Live đang gán cho bube-banktransfer — thêm mức « Theo số giao dịch » (Tingee: 150 ₫ / lượt, cả hợp đồng) ở mục Cách tính phí.",
  "issue.no_reading": "Chưa có số dư đọc từ cổng — nhập số dư hiện tại ở cổng baas.tingee.vn › Token.",
  "issue.reading_stale": "Số dư đọc từ cổng đã cũ (quá 30 ngày hoặc quá cửa sổ đo) — đọc lại để ước tính không trôi.",
  "issue.balance_exhausted": "Số dư ước tính dưới giá một lượt — Tingee đang hoặc sắp chặn webhook.",
  "issue.delivery_blocked": "Webhook không tới — giao dịch chỉ về qua đối soát kéo (thường là ví cạn, 402).",
  "issue.runway_short": "Còn dưới 14 ngày theo lưu lượng hiện tại.",
  "issue.lots_expiring": "Có lô sắp hết hạn mà sẽ không kịp tiêu hết — token đó sẽ mất.",
  balance: "Số dư ước tính",
  balanceHint: "Từ số đọc {anchor} lúc {at}: −{requests} lượt ({minor}), +{added} nạp / chỉnh, −{expired} hết hạn",
  runway: "Còn khoảng",
  runwayDays: "{days} ngày",
  runwayNever: "Không cạn — chưa có lượt tính phí",
  exhaustAt: "Cạn khoảng {at}",
  rate: "Tốc độ dự báo",
  rateValue: "{used} lượt / ngày",
  rateHint: "Lấy số lớn hơn: TB 7 ngày {avg} · 24 giờ qua {last24h}",
  unitPrice: "Giá / lượt",
  noPrice: "Chưa có giá",
  month: "Tháng này",
  prevMonth: "Tháng trước",
  monthValue: "{requests} lượt · {minor}",
  paidThisMonth: "Đã nạp tháng này",
  anchorAt: "Đọc số dư lúc {at}",
  noAnchor: "Chưa đọc số dư",
  drift: "Độ lệch lần đọc gần nhất",
  driftValue: "{drift} (đọc {read} · hub ước tính {estimated})",
  driftHint: "Âm = đối tác trừ nhiều hơn hub đếm (có loại webhook khác bị tính, hoặc đổi giá); dương = hub đếm dư.",
  expiring: "Sắp hết hạn",
  expiringValue: "{remaining} hết hạn {at} — ước tính mất {lost}",
  lots: "Lô còn số dư",
  "kind.reading": "Số dư đọc từ cổng",
  "kind.topup": "Lô nạp",
  "kind.bonus": "Lô tặng",
  "kind.adjustment": "Điều chỉnh",
  noExpiry: "Không hạn",
  "delivery.title": "Webhook về Bube",
  "delivery.state.blocked": "Bị chặn",
  "delivery.state.partial": "Lỡ một phần",
  "delivery.state.ok": "Bình thường",
  "delivery.state.unknown": "Chưa đo được",
  "delivery.detail": "{undelivered} giao dịch về qua đối soát mà webhook chưa tới · {push} webhook trong {minutes} phút qua",
  "delivery.lastPush": "Webhook gần nhất {at}",
  "delivery.reconcileFailed": "Đối soát kéo lỗi lúc {at}: {error}",
  "delivery.blockCodes": "Mã chặn: {codes}",
  "delivery.error": "Không đọc được số đo của bube-banktransfer: {error}",
  "quota.title": "Hạn mức giao dịch",
  "quota.none": "Không có hạn mức nào chạm 80 %.",
  "quota.product": "Gói tháng của Bube",
  "quota.row": "{name} · {used} / {quota} giao dịch",
  "quota.level.warn": "≥ 80 %",
  "quota.level.over": "Vượt",
  "quota.level.ok": "Ổn",
  "quota.error": "Không đọc được báo cáo đối tác để tính hạn mức: {error}",
  "days.title": "Theo ngày (giờ VN)",
  "days.day": "Ngày",
  "days.requests": "Lượt tính phí",
  "days.minor": "Token",
  "days.other": "Webhook khác",
  "days.otherHint": "Webhook hub giả định không bị tính (trạng thái VA, Bank Link) — để đối chiếu độ lệch.",
  "days.pullOnly": "Chỉ về qua đối soát",
  "days.pullOnlyHint": "Giao dịch webhook không tới — dấu vết lúc Tingee chặn webhook.",
  "days.pushLate": "Webhook tới muộn",
  "ledger.title": "Sổ ví",
  "ledger.show": "Xem sổ ví ({count})",
  "ledger.hide": "Ẩn sổ ví",
  "ledger.empty": "Chưa có dòng nào.",
  "ledger.kind": "Loại",
  "ledger.units": "Token",
  "ledger.paid": "Tiền trả",
  "ledger.occurredAt": "Thời điểm",
  "ledger.expiresAt": "Hạn dùng",
  "ledger.note": "Ghi chú",
  "ledger.by": "Người ghi",
  "ledger.delete": "Xoá",
  "ledger.confirmYes": "Xoá thật",
  "ledger.confirmNo": "Thôi",
  "ledger.confirmDelete": "Xoá dòng này? (có ghi audit)",
  "form.title": "Ghi vào sổ ví",
  "form.kind": "Loại",
  "form.units": "Số token",
  "form.unitsHint": "1 token = 1 ₫. Điều chỉnh được âm.",
  "form.paid": "Tiền đã trả (₫)",
  "form.occurredAt": "Thời điểm",
  "form.expiresAt": "Hạn dùng (để trống = không hạn)",
  "form.note": "Ghi chú",
  "form.save": "Ghi",
  "form.saving": "Đang ghi…",
  "form.saved": "Đã ghi.",
  "form.hint.reading": "Số dư hiện tại ở cổng baas.tingee.vn › Token — mốc để hub ước tính.",
  "form.hint.topup": "Lô token vừa nạp (sau mốc đọc số dư): số token, tiền đã trả, hạn dùng của lô.",
  "form.hint.bonus": "Lô token được tặng (khuyến mãi) — thường có hạn ngắn.",
  "form.hint.adjustment": "Chỉnh tay khi đối tác trừ / cộng ngoài lệ (± token).",
  "strip.title": "Ví & hạn mức đối tác",
  "strip.open": "Chi tiết",
  "strip.allOk": "Ví đủ dùng, webhook tới bình thường, không hạn mức nào chạm 80 %.",
  "strip.wallet": "{name}: {balance} · còn {days}",
  "strip.walletNoDays": "{name}: {balance}",
  "strip.nextExpiry": "lô hết hạn {at}",
};
